/**
 * Normalize GET /accounts/visible (and similar) JSON into an accounts array.
 * Handles { data: [] }, { data: { data: [] } }, { accounts: [] }, etc.
 */
export function accountsArrayFromResponse(response) {
  if (!response || typeof response !== 'object') return [];
  const d = response.data;
  if (Array.isArray(d)) return d;
  if (d && typeof d === 'object' && Array.isArray(d.data)) return d.data;
  if (d && typeof d === 'object' && Array.isArray(d.accounts)) return d.accounts;
  if (Array.isArray(response.accounts)) return response.accounts;
  if (Array.isArray(response.results)) return response.results;
  if (Array.isArray(response.result)) return response.result;
  return [];
}
